var contactList = {
    cityFilterSelector: "[data-cityfilter]",
    roleFilterSelector: "[data-rolefilter]",
    itemsSelector: "[data-contactitem]",
    contactListContainer: "#contact-list-container",

    init: (contactListElement) => {
        const cityFilterSelect = contactListElement.querySelector(contactList.cityFilterSelector);
        const roleFilterSelect = contactListElement.querySelector(contactList.roleFilterSelector);

        contactList.checkUrlParams(cityFilterSelect, roleFilterSelect, contactListElement);

        if (cityFilterSelect) {
            contactList.initDynamicDefaultOptionText(cityFilterSelect);
            const cityIcon = cityFilterSelect.nextElementSibling;
            contactList.updateSelect(cityFilterSelect, cityIcon);

            cityFilterSelect.addEventListener("change", () => {
                contactList.updateList(contactListElement);
                if (cityFilterSelect.value === "") cityFilterSelect.selectedIndex = 0;
                utils.url.updateURLParamSingle('city', cityFilterSelect.value);
            });
        }

        if (roleFilterSelect) {
            contactList.initDynamicDefaultOptionText(roleFilterSelect);
            const roleIcon = roleFilterSelect.nextElementSibling;
            contactList.updateSelect(roleFilterSelect, roleIcon);

            roleFilterSelect.addEventListener("change", () => {
                contactList.updateList(contactListElement);
                if (roleFilterSelect.value === "") roleFilterSelect.selectedIndex = 0;
                utils.url.updateURLParamSingle('role', roleFilterSelect.value);
            });
        }
    },

    checkUrlParams: (cityFilterSelect, roleFilterSelect, contactListElement) => {
        const urlParams = new URLSearchParams(window.location.search);
        const cityParam = urlParams.get('city');
        const roleParam = urlParams.get('role');

        if (cityParam && cityFilterSelect) {
            cityFilterSelect.value = cityParam;
        }
        if (roleParam && roleFilterSelect) {
            roleFilterSelect.value = roleParam;
        }

        contactList.updateList(contactListElement);
    },

    updateList: (contactListElement) => {
        const cityFilterSelect = contactListElement.querySelector(contactList.cityFilterSelector);
        const roleFilterSelect = contactListElement.querySelector(contactList.roleFilterSelector);
        const items = contactListElement.querySelectorAll(contactList.itemsSelector);

        const cityFilterValue = cityFilterSelect?.value || "";
        const roleFilterValue = roleFilterSelect?.value || "";

        const { cityToRoles, roleToCities } = contactList.getCityRoleMap(items);

        let visibleRoles = new Set();
        let visibleCities = new Set();

        if (cityFilterValue && !roleFilterValue) {
            // Only city selected
            visibleRoles = cityToRoles.get(cityFilterValue) ?? new Set();
            Array.from(cityFilterSelect.options).forEach(option => {
                if (option.value !== "") visibleCities.add(option.value);
            });
        } else if (!cityFilterValue && roleFilterValue) {
            // Only role selected
            visibleCities = roleToCities.get(roleFilterValue) ?? new Set();
            Array.from(roleFilterSelect.options).forEach(option => {
                if (option.value !== "") visibleRoles.add(option.value);
            });
        } else if (cityFilterValue && roleFilterValue) {
            visibleRoles = cityToRoles.get(cityFilterValue) ?? new Set();
            visibleCities = roleToCities.get(roleFilterValue) ?? new Set();
        } else {
            // Nothing selected
            Array.from(roleFilterSelect.options).forEach(option => {
                if (option.value !== "") visibleRoles.add(option.value);
            });
            Array.from(cityFilterSelect.options).forEach(option => {
                if (option.value !== "") visibleCities.add(option.value);
            });
        }

        // Filter visible contact items
        let visibleItemsCount = 0;
        items.forEach(item => {
            const cities = item.dataset.cities ? JSON.parse(item.dataset.cities) : [];
            const roles = item.dataset.roles ? JSON.parse(item.dataset.roles) : [];

            let isVisible = true;
            if (cityFilterValue && !cities.includes(cityFilterValue)) isVisible = false;
            if (roleFilterValue && !roles.includes(roleFilterValue)) isVisible = false;
            if (!cityFilterValue && !roleFilterValue) isVisible = false;

            if (isVisible) {
                utils.common.showElement(item);
                visibleItemsCount++;
            } else {
                utils.common.hideElement(item);
            }
        });

        contactList.updateListAria(contactListElement, visibleItemsCount === 0);
        contactList.updateSelectOptions(visibleRoles, visibleCities, cityFilterSelect, roleFilterSelect);
    },
    // Get relations
    getCityRoleMap: (items) => {
        const cityToRoles = new Map();
        const roleToCities = new Map();

        items.forEach(item => {
            const cities = item.dataset.cities ? JSON.parse(item.dataset.cities) : [];
            const roles = item.dataset.roles ? JSON.parse(item.dataset.roles) : [];

            cities.forEach(city => {
                if (!cityToRoles.has(city)) cityToRoles.set(city, new Set());
                roles.forEach(role => cityToRoles.get(city).add(role));
            });

            roles.forEach(role => {
                if (!roleToCities.has(role)) roleToCities.set(role, new Set());
                cities.forEach(city => roleToCities.get(role).add(city));
            });
        });

        return { cityToRoles, roleToCities };
    },

    updateSelectOptions: (visibleRoles, visibleCities, cityFilterSelect, roleFilterSelect) => {
        if (cityFilterSelect) {
            Array.from(cityFilterSelect.options).forEach(option => {
                if (option.value === "") {
                    option.disabled = false;
                    return;
                }
                option.disabled = visibleCities.size > 0 && !visibleCities.has(option.value);
            });
        }

        if (roleFilterSelect) {
            Array.from(roleFilterSelect.options).forEach(option => {
                if (option.value === "") {
                    option.disabled = false;
                    return;
                }
                option.disabled = visibleRoles.size > 0 && !visibleRoles.has(option.value);
            });
        }
    },

    resetSelectOptions: (selectElement) => {
        if (!selectElement) return;
        Array.from(selectElement.options).forEach(option => {
            option.disabled = false;
        });
    },

    updateSelect: (select, icon) => {
        select.addEventListener('click', () => {
            icon.classList.toggle('rotate-180');
        });
        select.addEventListener('blur', () => {
            icon.classList.remove('rotate-180');
        });
    },

    updateListAria: (contactListElement, hidden) => {
        const container = contactListElement.querySelector(contactList.contactListContainer);
        if (container) {
            container.setAttribute("aria-hidden", hidden);
        }
    },
    initDynamicDefaultOptionText: (select) => {
        const defaultOption = select.querySelector('option[value=""]');
        if (!defaultOption) return;

        const updateLabel = () => {
            const isDefault = select.value === "";
            defaultOption.textContent = isDefault
                ? defaultOption.dataset.placeholder
                : defaultOption.dataset.showall;
        };

        updateLabel();
        select.addEventListener("change", updateLabel);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const contactLists = document.querySelectorAll('[data-contactfilter]');
    contactLists.forEach(contactListElement => {
        contactList.init(contactListElement);
    });
});
